export default function VideoAE() {
    return (
        <>
            <section class="video-promo section bg-1">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="content-block">
                                <h2>After Event YISF 2025</h2>
                                <p>
                                    </p>
                                    <a data-fancybox href="https://youtu.be/dBIe6IuDkoI?si=uX2s9oIsP-bO1DAJ">
                                        <i class="ti-control-play video"></i>
                                    </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}